import type { Database } from '@kit/supabase/database';

type CompetitionCategoriesRow =
  Database['public']['Tables']['competition_categories']['Row'];

export type CompetitionFormat =
  Database['public']['Enums']['competition_format'];

export type CompetitionAgeDivision =
  Database['public']['Enums']['competition_age_division'];

export type DanceStyleType = Database['public']['Enums']['dance_style_type'];

export type CompetitionCategory = CompetitionCategoriesRow;

/**
 * Styles/categories separation (2026-06-04): a `competition_categories`
 * row IS one style entry — a {format, age_division, style} tuple the
 * dancer can tick. The dancer's own "category" is the auto-computed
 * `audition_applications.age_division` snapshot, not one of these rows.
 */
export type StyleEntry = CompetitionCategory;

export type CompetitionCategoryInsert =
  Database['public']['Tables']['competition_categories']['Insert'];

export type AuditionApplicationStyleEntryRow =
  Database['public']['Tables']['audition_application_style_entries']['Row'];

export const FORMAT_LABELS: Record<CompetitionFormat, string> = {
  solo: 'Solo',
  duet_trio: 'Duet/Trio',
  small_ensemble: 'Small Ensemble (4-10)',
  large_ensemble: 'Large Ensemble (11+)',
  ensemble: 'Ensemble: 4+ dancers',
  crew: 'Crew',
  small_crew: 'Small Crew (4-10)',
  large_crew: 'Large Crew (11+)',
};

export const AGE_DIVISION_LABELS: Record<CompetitionAgeDivision, string> = {
  mini: 'Mini (under 9)',
  junior: 'Junior (9-11)',
  teen: 'Teen (12-14)',
  intermediate: 'Intermediate (15-17)',
  senior: 'Senior (18+)',
};

export const AGE_DIVISION_RANGES: Record<
  CompetitionAgeDivision,
  { min: number; max: number }
> = {
  mini: { min: 5, max: 8 },
  junior: { min: 9, max: 11 },
  teen: { min: 12, max: 14 },
  intermediate: { min: 15, max: 17 },
  senior: { min: 18, max: 29 },
};

export const FORMAT_GROUP_SIZES: Record<
  CompetitionFormat,
  { min: number; max: number }
> = {
  solo: { min: 1, max: 1 },
  duet_trio: { min: 2, max: 3 },
  small_ensemble: { min: 4, max: 10 },
  large_ensemble: { min: 11, max: 50 },
  ensemble: { min: 4, max: 50 },
  crew: { min: 4, max: 50 },
  small_crew: { min: 4, max: 10 },
  large_crew: { min: 11, max: 50 },
};
